import { TrendingUp } from 'lucide-react';
import { cn } from '@/lib/cn';

/**
 * Lockup de marca de BetStock IA. `compact` muestra solo la marca con gradiente.
 * Decía "StockAI · Predicción Inteligente": nombre viejo y una promesa genérica. El producto
 * se llama BetStock IA (package.json, CLAUDE.md, Topbar) y lo que hace es forecast de demanda.
 */
export function Logo({ compact = false }: { compact?: boolean }) {
  return (
    <div className="flex items-center gap-2.5">
      <div className="grid h-9 w-9 shrink-0 place-items-center rounded-xl bg-gradient-to-br from-primary-ring to-info shadow-glow">
        <TrendingUp className="h-5 w-5 text-white" strokeWidth={2.5} />
      </div>
      {!compact && (
        <div className="min-w-0 leading-tight">
          <p className="text-[15px] font-bold tracking-tight text-ink-strong">BetStock IA</p>
          {/* `whitespace-nowrap`: con la tipografía nueva la bajada se partía en dos
              líneas y descuadraba el alto de la cabecera. */}
          <p className={cn('whitespace-nowrap text-2xs uppercase tracking-[0.1em] text-info-text')}>
            Forecast de demanda
          </p>
        </div>
      )}
    </div>
  );
}
